import React, { useState, useEffect } from "react";
import { connect } from 'react-redux';
import { Actions as ACTIONS } from '../../store/actions/workLocationActions';
import { format, addMonths, lastDayOfMonth } from 'date-fns';
import _ from 'lodash';
import { PhotoIcon, ChatBubbleOvalLeftEllipsisIcon
, PencilSquareIcon, XMarkIcon, CheckIcon } from '@heroicons/react/20/solid'
import Spinner from '../common/Spinner'

const WorkLocationRow = ({
  workLocation,
  workLocationType,
  setOpenModal,
  noName,
  mode,
  userPermissions,
  saveWorkLocation,
  currentDepartment,
  currentAgreement,
  employee,

  isSaving,
  showCancelWorkLocation,
  showComments,
  showAttachments,
}) => {

  const onChangeWorkLocationStatus = (status) => {

    const workLocationData = {
      agreement: workLocation.agreement || workLocation.agreement || currentAgreement,
      status: status,
      id: workLocation.entry_id || workLocation.id
    }

    if (mode == "manager") {
      workLocationData.teamID = currentDepartment
    }

    saveWorkLocation(workLocationData);

  }


  const sameDay = !workLocation.dateTo || workLocation.date == workLocation.dateTo

  if (!employee && !workLocation.employeeName) {
    // this is an employee which doesn't work in this period
    return null;
  }

  return (
    <tr>
      {employee && employee.employeeName ?
        <td>
          {employee.employeeName} {employee.employeeSurname}
        </td>
        :
        <td>
          {workLocation.employeeName} {workLocation.employeeSurname}
        </td>
      }
      {employee &&
        <td>
          {employee.departmentName}
        </td>
      }
      <td>
        {workLocation.applicationDate && format(new Date(workLocation.applicationDate), "do MMM yyyy") || format(new Date(), "do MMM yyyy")}
      </td>
      <td>
        {format(new Date(workLocation.date), "do MMM yyyy")}
        {sameDay && ` ${workLocation.startTime}`}
      </td>
      <td>
        {sameDay ? workLocation.endTime : format(new Date(workLocation.dateTo), "do MMM yyyy")}
      </td>
      <td>
        {parseFloat(workLocation.hours).toFixed(2)}
      </td>
      <td>
        {workLocationType && workLocationType.name}
      </td>
      <td>
        {workLocation.status}
      </td>
      <td className="text-center">
        {isSaving &&
          <a style={{ marginRight: "5px" }} className="btn btn-xs btn-default" title="Saving">
            <Spinner
              style={{ height: "1.5em", verticalAlign: 'middle'}}
              className="animate-spin -ml-1 mr-3 h-5 w-5 "
            />
          </a>
        }
        {!isSaving && workLocation.comments && workLocation.comments.length > 0 &&
          <a style={{ marginRight: "5px" }} className="btn btn-xs btn-default" title="Show Comments" onClick={() => { showComments(workLocation) }}>
            <ChatBubbleOvalLeftEllipsisIcon
 style={{ height: "1.5em", float: "left"}} />
          </a>
        }
        {!isSaving && workLocation.attachments && workLocation.attachments.length > 0 &&
          <a style={{ marginRight: "5px" }} className="btn btn-xs btn-default" title="Show Comments" onClick={() => { showAttachments(workLocation) }}>
            <PhotoIcon style={{ height: "1.5em", float: "left" }} />
          </a>
        }

        {!isSaving && userPermissions != "Read" && workLocation.status == "Pending" &&
          <React.Fragment>
            <a
              style={{ marginRight: "5px" }}
              className="btn btn-xs btn-success" title="Approve Work Location Request" onClick={() => { onChangeWorkLocationStatus("Approved") }}>
              <CheckIcon style={{ height: "1.5em", float: "left"}} />
            </a>
            <a
              style={{ marginRight: "5px" }}
              className="btn btn-xs btn-danger" title="Deny Work Location Request" onClick={() => { showCancelWorkLocation(workLocation, "Denied") }}>
              <XMarkIcon style={{ height: "1.5em", float: "left" }} />
            </a>
          </React.Fragment>
        }

        {!isSaving && userPermissions != "Read"  && workLocation.status == "Pending Cancellation" &&
          <React.Fragment>
            <a
              style={{ marginRight: "5px" }}
              className="btn btn-xs btn-success" title="Keep Work Location" onClick={() => { onChangeWorkLocationStatus("Approved") }}>
              <CheckIcon style={{ height: "1.5em", float: "left"}} />
            </a>
            <a
              style={{ marginRight: "5px" }}
              className="btn btn-xs btn-danger" title="Cancel Work Location" onClick={() => { showCancelWorkLocation(workLocation, "Cancelled") }}>
              <XMarkIcon style={{ height: "1.5em", float: "left" }} />
            </a>
          </React.Fragment>
        }

        {!isSaving && userPermissions != "Read"  &&
          <a className="btn btn-xs btn-default" title="Edit Work Location Request" onClick={() => { setOpenModal(true, workLocation) }}>
            <PencilSquareIcon style={{ height: "1.5em", float: "left" }} />
          </a>
        }

        {
          !userPermissions != "Read"  && workLocation.payPeriodNo &&
          <span>
            {
              workLocation.payPeriodFrequency == 12 ?
                `Paid ${format(new Date(2020, workLocation.payPeriodNo - 1, 1), "MMM")} ${workLocation.payPeriodYear}`
                : `Paid ${workLocation.payPeriodNo} ${workLocation.payPeriodYear}`
            }
          </span>
        }
      </td>
    </tr>
  )
}


const mapStateToProps = (state, ownProps) => {

  const {
    // workLocation,
    types,
  } = state.workLocation

  const {
    workLocation,
  } = ownProps
  const userPermissions = state?.permissions?.my?.permissions?.workLocations

  // TODO update lock date
  const isBeforeLockDate = new Date(workLocation.start) <= lastDayOfMonth(addMonths(new Date(), -1))
  const employeeOptions = state && state.employees && state.employees.employeeListWithSalary

  const isSaving = state.workLocation.saving && state.workLocation.saving[workLocation.id]

  const {
    // workLocation,
    employeeListWithSalary,
  } = state.employees

  const employee = employeeListWithSalary && employeeListWithSalary.find(employee => employee.id == workLocation.agreement)
  // console.log('employeeForRow',employeeListWithSalary,employee,workLocation.agreement)

  return {
    workLocationType: types && workLocation && _.find(types, { id: workLocation.type }),
    employee,
    employeeOptions,
    isSaving,
    userPermissions,
  }
}

const mapDispatchToProps = dispatch => ({
  setOpenModal: (status, workLocation) => dispatch(ACTIONS.setOpenModal(status, workLocation)),
  saveWorkLocation: (workLocation) => dispatch(ACTIONS.saveWorkLocation(workLocation)),
  showCancelWorkLocation: (workLocation, status) => dispatch(ACTIONS.showCancelWorkLocation(workLocation, status)),
  showComments: (workLocation) => dispatch(ACTIONS.showComments(workLocation)),
  showAttachments: (workLocation) => dispatch(ACTIONS.showAttachments(workLocation)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WorkLocationRow) 